/**
 * PendingPractitionerBanner — Amber info banner for pending invitations.
 *
 * Shown inside PractitionerConsentCard when status is 'pending'.
 * All toggles are disabled until the practitioner accepts.
 */

import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useTranslation } from '@dramadetector/shared';

interface PendingPractitionerBannerProps {
  practitionerName: string;
}

export const PendingPractitionerBanner: React.FC<PendingPractitionerBannerProps> = React.memo(
  function PendingPractitionerBanner({ practitionerName }) {
    const { t } = useTranslation('practitioner_consent');

    return (
      <View style={styles.container} accessibilityRole="text">
        <Text style={styles.icon} accessibilityElementsHidden={true}>
          🕐
        </Text>
        <Text style={styles.message}>
          {t('pending_banner.message', { name: practitionerName })}
        </Text>
      </View>
    );
  }
);

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: 'rgba(251, 191, 36, 0.08)',
  },
  icon: {
    fontSize: 14,
    flexShrink: 0,
    color: '#F59E0B',
  },
  message: {
    flex: 1,
    fontSize: 12,
    color: '#71717A',
    lineHeight: 18,
  },
});
